export default __webpack_public_path__ + "static/media/no-check.fe894ae6.svg";